import React, { useEffect, useState } from 'react'
import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll'

const Modal = ({ isModalOpen, setIsModalOpen, children }) => {
    const onDismiss = (isModalOpen) => {
        setIsModalOpen(!isModalOpen)
        document.body.style.overflow = 'unset';
    }

    useDisableBodyScroll(isModalOpen)

    return (
        <div className='overlayPopup dismiss overflow-hidden'>
                {children}
        </div>
    )
} 

export default Modal